import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react'
import images from '../images/images'
import './FailedUpdatePackage.scss'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import { isBrowser, isMobileOnly } from 'react-device-detect';
import {  } from '../../cellcomAbroadBlockSlice'
import { connect } from 'react-redux';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import Lottie from 'react-lottie';
import PaperPlane from '../../../../../animations/paperPlane.json';
import PisaTower from '../../../../../animations/fallingTower.json';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../../utilities/theme/ThemeColorEnum';


function FailedCancelPackage({ onClose, resetSocPackageRemoveStatus }) {

    function goBack() {
        resetSocPackageRemoveStatus(null);
        onClose();
    }

    useEffect(() => {
        return () => {
            goBack()
        }
    },[])

    return (
        <div className="failed-update-package-container">
            <div className="header">רגע, יש כאן עניין</div>
            {/* <Lottie  options={{animationData: PisaTower, loop: false}} width={isMobileOnly ? 80 : 125} /> */}
           <ThemedLottie animationData={PisaTower}  color={ThemeColorEnum.PRIMARY} loop={false} width={isMobileOnly ? 80 : 125} />
            <p className="p-main">
                <span className="strong">לא הצלחנו לבטל את החבילה</span>
                <br />
                <span>אפשר לנסות שוב או לפנות אלינו למוקד השירות</span>
            </p>
            <div className="contact-box">
                <span className="txt-header">דברו איתנו</span>
                <div className="under-box">
                    <Image className="phone-img" src={images.phoneCall} alt="phone" />
                    <span className="txt">{window.Config.numberCallCenterAbroad}</span>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({

});


const mapDispatchToProps = {

};

export default connect(null, mapDispatchToProps)(FailedCancelPackage);